<template>
    <div id="login" :style="'background:url('+backImg+') 0% 0% / 100% 100%;'">
        <div class="box">
            <p class="title">{{sitename}}</p>
            <p class="info">管理系统</p>
            <el-form :model="form" class="form">
                <el-form-item>
                    <el-input v-model="form.mobile" placeholder="请输入用户名">
                        <i slot="prefix" class="el-input__icon el-icon-user"></i>
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="form.password" placeholder="请输入密码" type="password">
                        <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                    </el-input>
                </el-form-item>
            </el-form>
            <el-button type="primary" style="width:200px" @click="loginIn">登录</el-button>
            <p class="forget" @click="toForget">忘记密码</p>
            <p class="register" @click="toRegister">注册</p>

        </div>
    </div>
</template>

<script>
import { login, getback, getConfig } from '@/api/login'
export default {
    name: "loginIn",
    data() {
        return {
            form: {
                mobile: '',
                password: '',
                qwertyuiop: '',
            },
            // backImg: 'http://150.158.183.198/uploads/20230106/1ab733f5d0e6e9823652ef68724054e2.webp'
            backImg: '',
            sitename: '佰佬汇'
        }
    },
    created() {
        this.getBackImg()
        this.getConfig()
        if (this.$route.query.qwertyuiop) {
            this.form.qwertyuiop = this.$route.query.qwertyuiop;
            this.loginIn();
        }
    },
    methods: {
        getBackImg() {
            getback().then(res => {
                this.backImg = res.data.shop_theme_background
            })
        },
        getConfig() {
            getConfig().then(res => {
                this.sitename = res.data.name
            })
        },
        loginIn() {
            let data = {
                mobile: this.form.mobile,
                password: this.form.password,
                qwertyuiop: this.form.qwertyuiop
            }
            login(data).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: '登录成功',
                        type: "success",
                    });
                    this.$store.commit("changeLogin", res.data.token);
                    this.$router.push({
                        name: 'report'
                    })
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            })
        },
        toForget() {
            this.$router.push({
                name: 'repassword',
            })
        },
        toRegister() {
            this.$router.push({
                name: 'register',
            })

        },
    }
};
</script>

<style lang="scss" scoped>
#login {
    width: 100%;
    height: 100vh;
    // background: url("https://img0.baidu.com/it/u=4048401711,794461287&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500")
    //     no-repeat;
    background-size: 100% 100%;
    position: relative;
    .box {
        width: 450px;
        height: 400px;
        border-radius: 20px;
        background: rgba(0, 0, 0, 0.5);
        text-align: left;
        padding: 30px;
        color: white;
        position: absolute;
        right: 10%;
        bottom: 30%;
        .title {
            font-size: 35px;
        }
        .info {
            font-size: 18px;
            margin-top: 20px;
        }
        .form {
            margin-top: 20px;
        }
        .forget {
            color: white;
            font-size: 13px;
            position: absolute;
            right: 30px;
            bottom: 30px;
            cursor: pointer;
        }
        .register {
            color: white;
            font-size: 13px;
            position: absolute;
            left: 30px;
            bottom: 30px;
            cursor: pointer;
        }
    }
}
</style>
